/**
 * TanStack Router: /team-evaluation
 *
 * This route file was auto-generated by the route generation script.
 * Component: TeamEvaluationPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import TeamEvaluationPage from '@/app/team-evaluation/page'

/**
 * Route: /team-evaluation
 * Layout: _auth (authenticated)
 * Component: TeamEvaluationPage
 */
export const Route = createFileRoute('/_auth/team-evaluation')({
  component: TeamEvaluationPage,
})
